import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, GraduationCap, Instagram } from "lucide-react";
import { useState } from "react";
import { BRAND, waLink } from "@/lib/brand";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/courses", label: "Courses" },
  { to: "/results", label: "Results" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/study-materials", label: "Study Materials" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/student/login", label: "Student Portal" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleBookDemo = () => {
    // Open WhatsApp in a new tab AND navigate to the enquiry page
    window.open(waLink(), "_blank", "noopener,noreferrer");
    navigate("/contact");
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 group">
          <span className="w-9 h-9 rounded-md bg-[#0B192C] text-white grid place-items-center">
            <GraduationCap size={20} className="text-[#FF6B35]" />
          </span>
          <div className="leading-none">
            <div className="font-display text-base sm:text-lg font-800 tracking-tight text-[#0B192C] uppercase whitespace-nowrap">Vikramshila Classes</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive ? "text-[#FF6B35]" : "text-slate-700 hover:text-[#0B192C] hover:bg-slate-100"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="header-instagram-btn" aria-label="Instagram" className="w-9 h-9 grid place-items-center rounded-md text-slate-600 hover:text-white transition-colors" style={{ background: "linear-gradient(45deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%)", color: "white" }}>
            <Instagram size={16} />
          </a>
          <button type="button" onClick={handleBookDemo} data-testid="header-whatsapp-btn" className="vk-btn-primary text-sm">
            Book Free Demo
          </button>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#0B192C]"
          data-testid="header-mobile-menu-btn"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm ${isActive ? "text-[#FF6B35]" : "text-slate-700"}`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
            <button type="button" onClick={handleBookDemo} className="vk-btn-primary text-sm mt-2 justify-center">
              Book Free Demo
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
